module.exports = __webpack_public_path__ + "img/horizontal_4_4_1.ed2046d6.png";